import CheckBoxOutlineBlankOutlinedIcon from '@mui/icons-material/CheckBoxOutlineBlankOutlined';
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Box } from '@mui/material';
import React from "react";
import CheckboxTree from 'react-checkbox-tree';
import 'react-checkbox-tree/lib/react-checkbox-tree.css';

export const MyMTreeCheckbox = (props) => {
  const { name, treeItemList, expanded, setExpanded, checkedList, setCheckedList, needsCascade, sx, ...other } = props;
  const minLv = treeItemList.map(x => x.Lv).reduce((a, b) => Math.min(a, b));

  const convertTreeItem = (item) => {
    const treeItem = { value: item.Id, label: item.Name };
    if (treeItemList.some(x => x.ParentId === treeItem.value)) {
      treeItem.children = treeItemList.filter(x => x.ParentId === treeItem.value).map(x => convertTreeItem(x));
    }

    return treeItem;
  }

  /**
   * Check event
   * @param {Number[]} checkValueList
   */
  const onCheck = (checkValueList) => {

    // 連動不要の場合、規定の処理を行い終了
    if (!needsCascade) {
      setCheckedList(checkValueList);
      return;
    }

    const getParentValues = (childId) => {
      const children = treeItemList.filter(x => x.Id === Number(childId));
      let parentValues = children.map(x => String(x.ParentId)).filter(x => x !== 'null');
      parentValues.forEach(x => parentValues.push(...getParentValues(x)));
      return parentValues;
    }

    const getChildValues = (parentId) => {
      const children = treeItemList.filter(x => x.ParentId === parentId);
      let childValues = children.map(x => String(x.Id));
      children.forEach(x => childValues.push(...getChildValues(x.Id)));
      return childValues;
    }

    const combinedList = [...checkValueList, ...checkedList];
    const changedValue = Number(combinedList.find(x => combinedList.indexOf(x) === combinedList.lastIndexOf(x)));
    if (checkValueList.length > checkedList.length) {
      const parentValues = getParentValues(changedValue);
      const childValues = getChildValues(changedValue);
      const updatedList = [...checkValueList, ...parentValues, ...childValues];
      setCheckedList(updatedList.filter((x, i) => updatedList.indexOf(x) === i));
    } else {
      const childValues = getChildValues(changedValue);
      const newCheckedList = checkValueList.filter(x => childValues.indexOf(x) === -1);
      setCheckedList(newCheckedList);
    }
  }

  const hierarchyLineBaseMargin = expanded ? 20 : 10;

  return (
    <Box
      sx={{
        ...sx,
        padding: '0px 10px 10px 10px',
        'ol > li': {
          ' > span': { minHeight: '30px' },
          // 下記、階層用の予備線を描画
          ' > ol > li': {
            '&.rct-node': {
              position: 'relative',
              '&:before': { position: 'absolute', paddingTop: '2px', marginLeft: `${-hierarchyLineBaseMargin}px`, 'content': '"─"' },
              '&:not(:last-of-type)': { borderLeft: 'solid 1px black', marginLeft: `${-hierarchyLineBaseMargin}px`, paddingLeft: `${hierarchyLineBaseMargin}px`, },
              '&:last-of-type:before': { height: '15px', paddingTop: '3px', borderLeft: 'solid 1px black' },
              '&:last-of-type > .rct-text': { marginLeft: '1px' },
              '&.rct-node-parent:last-of-type > .rct-text': { marginLeft: expanded ? '1px' : '6px' },
              '&.rct-node-expanded > .rct-text': { marginLeft: expanded ? '1px' : '3px' },
            }
          }
        },
        '.react-checkbox-tree ol ol': { paddingLeft: expanded ? '60px' : '24px' },
        '[aria-label=Toggle]': { width: !expanded ? '0' : 'auto', padding: 0 },
        '.react-checkbox-tree button:disabled': { cursor: !expanded && 'auto' },
        '.rct-checkbox *, .rct-node-icon *': { width: 'auto', fontSize: 23 },
        '.rct-collapse': { paddingLeft: '2px', marginRight: expanded ? '24px' : '0px', width: 0 },
        '.rct-node-leaf .rct-collapse': { marginRight: '0px' },
        '.rct-checkbox': { verticalAlign: 'text-bottom', paddingLeft: '0px', display: 'inline-flex' }
      }}>
      <CheckboxTree
        nodes={treeItemList.filter(x => x.Lv === minLv).map(x => convertTreeItem(x))}
        name={name}
        checked={checkedList}
        expanded={expanded ?? treeItemList.map(x => x.Id)}
        expandDisabled={setExpanded ? false : true}
        checkModel='all'
        noCascade={true}
        onCheck={checked => onCheck(checked)}
        onExpand={expanded => { setExpanded && setExpanded(expanded) }}
        showNodeIcon={false}
        icons={{
          check: <CheckBoxOutlinedIcon />,
          uncheck: <CheckBoxOutlineBlankOutlinedIcon />,
          halfCheck: <CheckBoxOutlineBlankOutlinedIcon />,
          expandClose: expanded && <ChevronRightIcon />,
          expandOpen: expanded && <ExpandMoreIcon />,
          parentOpen: <CheckBoxOutlineBlankOutlinedIcon />,
        }}
        {...other}
      />
    </Box>
  );
}